// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"ac1747e3","197":"4f1b6a47","453":"c9fa93a2"}[chunkId] + ".chunk.js";
};